import DMTableSection from "./DMTableSection";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import Heading from "../../components/Heading";

const DefaultManagement = ({ logout }) => {
  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Default Management" />,
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
    {
      component: <DMTableSection className="col-sm-12" />,
      role: ["Both"],
      className: "col-sm-12",
    },
  ];

  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};
export default DefaultManagement;
